import { initializeApp } from "firebase/app";
import { Capacitor } from "@capacitor/core";
import { indexedDBLocalPersistence, setPersistence, getAuth } from "firebase/auth";
import { FIREBASE_CONFIG } from "./config";

class FirebaseApp {

    static getInstance() {

		const app = initializeApp(FIREBASE_CONFIG);
		
		if(Capacitor.isNativePlatform()) {
			setPersistence(getAuth(app), indexedDBLocalPersistence);
		}

		return app;
    }

}

export default FirebaseApp;